import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import logoWhite from "@/assets/ping-logo-white.png";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

function formatErr(detail) {
  if (!detail) return "Login failed. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin/products");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex items-baseline gap-2 justify-center mb-2">
          <img src={logoWhite} alt="PING" className="h-9 w-auto" />
          <span className="text-[10px] tracking-[0.3em] uppercase text-white/50">India</span>
        </div>
        <p className="text-center label-caps text-white/40 mb-10">Distributor Admin</p>

        <form onSubmit={submit} className="border border-[#27272A] p-8 bg-[#111111]">
          <h1 className="heading-3 mb-6 flex items-center gap-2"><Lock className="h-5 w-5 text-[#E31837]" /> Sign In</h1>
          <div className="space-y-5">
            <div>
              <Label htmlFor="email" className="label-caps text-white/50">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-2 rounded-none bg-[#0A0A0A] border-[#27272A] text-white focus-visible:ring-2 focus-visible:ring-[#E31837]" data-testid="admin-email" />
            </div>
            <div>
              <Label htmlFor="password" className="label-caps text-white/50">Password</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-2 rounded-none bg-[#0A0A0A] border-[#27272A] text-white focus-visible:ring-2 focus-visible:ring-[#E31837]" data-testid="admin-password" />
            </div>
          </div>
          <button type="submit" disabled={loading}
            className="w-full mt-8 bg-[#E31837] text-white py-4 label-caps btn-transition hover:bg-[#b3122c] active:scale-[0.98] disabled:opacity-60"
            data-testid="admin-login-btn">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
